/* src/app/modules/file/files.component.css */
:host {
  --fm-brand: var(--cf-brand-dark, #d48f00);
  --fm-brand-dark: #b8790a;
  --fm-brand-light: rgba(212, 143, 0, 0.10);
  --fm-danger: #dc2626;
  --fm-danger-light: rgba(220, 38, 38, 0.08);
  --fm-bg: #f8f9fa;
  --fm-surface: #ffffff;
  --fm-border: #dadce0;
  --fm-hover: #f1f3f4;
  --fm-text: #202124;
  --fm-muted: #5f6368;
  --fm-light: #9aa0a6;
  --fm-radius: 8px;
  --fm-shadow: 0 1px 3px rgba(0,0,0,.08), 0 1px 2px rgba(0,0,0,.06);
}
.fm {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--fm-bg);
  position: relative;
  font-family:
    "Inter Tight",
    Roboto,
    Arial,
    sans-serif;
}
.fm--dragging {
  outline: 3px dashed var(--fm-brand);
  outline-offset: -4px;
}
.fm-drop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(255, 152, 0, 0.08);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.fm-drop-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 64px;
  background: var(--fm-surface);
  border: 2px dashed var(--fm-brand);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, .12);
}
.fm-drop-card__icon {
  font-size: 56px !important;
  width: 56px !important;
  height: 56px !important;
  color: var(--fm-brand);
}
.fm-drop-card__text {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--fm-text);
}
.fm-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 16px;
  height: 64px;
  background: var(--fm-surface);
  border-bottom: 1px solid var(--fm-border);
  position: sticky;
  top: 0;
  z-index: 100;
  flex-shrink: 0;
}
.fm-bar__start,
.fm-bar__end {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.fm-bar__start {
  flex: 1;
  overflow: hidden;
}
.fm-bar__end {
  flex-shrink: 0;
}
.fm-back-btn {
  color: var(--fm-muted) !important;
  flex-shrink: 0;
}
.fm-crumb {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow: hidden;
  min-width: 0;
}
.fm-crumb__root-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--fm-brand-light);
  flex-shrink: 0;
}
.fm-crumb__root {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  color: var(--fm-brand);
  flex-shrink: 0;
}
.fm-crumb__root-label {
  font-weight: 700 !important;
}
.fm-crumb__sep {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  color: var(--fm-light);
  flex-shrink: 0;
}
.fm-crumb__btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: var(--fm-muted);
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fm-crumb__btn:hover {
  background: var(--fm-hover);
  color: var(--fm-text);
}
.fm-crumb__current {
  font-size: 14px;
  font-weight: 600;
  color: var(--fm-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
  padding: 4px 6px;
}
.fm-search {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--fm-bg);
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0 12px 0 14px;
  height: 44px;
  width: 260px;
  cursor: text;
  transition:
    background 0.2s,
    box-shadow 0.2s,
    border-color 0.2s;
}
.fm-search--active,
.fm-search:focus-within {
  background: var(--fm-surface);
  border-color: var(--fm-brand);
  box-shadow: 0 0 0 3px var(--fm-brand-light);
}
.fm-search__icon {
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  color: var(--fm-muted);
  flex-shrink: 0;
}
.fm-search__input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: var(--fm-text);
  min-width: 0;
}
.fm-search__input::placeholder {
  color: var(--fm-muted);
}
.fm-search__clear {
  width: 28px !important;
  height: 28px !important;
  line-height: 28px !important;
  flex-shrink: 0;
  color: var(--fm-muted) !important;
}
.fm-search__clear mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
}
.fm-btn-ghost {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  color: var(--fm-muted) !important;
  border-radius: var(--fm-radius) !important;
  font-size: 13px !important;
  height: 36px !important;
  padding: 0 12px !important;
  transition: background 0.15s !important;
}
.fm-btn-ghost:hover {
  background: var(--fm-hover) !important;
  color: var(--fm-text) !important;
}
.fm-btn-ghost mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
}
.fm-btn-ghost__label {
  white-space: nowrap;
}
@media (max-width: 680px) {
  .fm-btn-ghost__label {
    display: none;
  }
}
.fm-btn-primary {
  background: var(--fm-brand) !important;
  color: #fff !important;
  border-radius: 999px !important;
  padding: 0 20px !important;
  height: 40px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .15) !important;
  transition: background 0.15s, box-shadow 0.15s !important;
}
.fm-btn-primary:hover {
  background: var(--fm-brand-dark) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .2) !important;
}
.fm-btn-primary mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
}
.fm-btn-primary--lg {
  border-radius: var(--fm-radius) !important;
  padding: 0 24px !important;
  height: 44px !important;
}
.fm-btn-outline {
  border-color: var(--fm-border) !important;
  color: var(--fm-muted) !important;
  border-radius: var(--fm-radius) !important;
}
.fm-btn-outline:hover {
  background: var(--fm-hover) !important;
  color: var(--fm-text) !important;
}
.fm-ocr-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  height: 44px;
  background: #fff8e1;
  border-bottom: 1px solid #ffe082;
  font-size: 13px;
  color: #6d4c00;
  flex-shrink: 0;
}
.fm-ocr-bar__icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  color: #f57c00;
}
.fm-ocr-bar__icon--sm {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
}
.fm-ocr-bar__label {
  font-weight: 500;
}
.fm-ocr-bar__sep {
  display: block;
  width: 1px;
  height: 20px;
  background: #ffe082;
  margin: 0 6px;
}
.fm-ocr-bar__pages {
  color: var(--fm-muted);
}
.fm-ocr-bar__help {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  color: var(--fm-light);
  cursor: help;
  margin-left: -4px;
}
.fm-main {
  flex: 1;
  padding: 16px 20px 20px;
  display: flex;
  flex-direction: column;
}
.fm-card {
  background: var(--fm-surface);
  border: 1px solid var(--fm-border);
  border-radius: var(--fm-radius);
  overflow: hidden;
  box-shadow: var(--fm-shadow);
  display: flex;
  flex-direction: column;
}
::ng-deep .fm-card .mat-mdc-card,
::ng-deep .fm-card .mdc-card,
::ng-deep .fm-card [class*=mat-elevation] {
  box-shadow: none !important;
  border-radius: 0 !important;
}
::ng-deep .fm-card mat-header-row,
::ng-deep .fm-card .mat-mdc-header-row {
  background: var(--fm-bg) !important;
  border-bottom: 1px solid var(--fm-border) !important;
  min-height: 42px !important;
}
::ng-deep .fm-card mat-header-cell,
::ng-deep .fm-card .mat-mdc-header-cell {
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: .06em !important;
  color: var(--fm-muted) !important;
}
::ng-deep .fm-card mat-row,
::ng-deep .fm-card .mat-mdc-row {
  cursor: pointer;
  min-height: 48px !important;
  border-bottom: 1px solid #f0f0f0 !important;
  transition: background 0.1s;
}
::ng-deep .fm-card mat-row:last-child,
::ng-deep .fm-card .mat-mdc-row:last-child {
  border-bottom: none !important;
}
::ng-deep .fm-card mat-row:hover,
::ng-deep .fm-card .mat-mdc-row:hover {
  background: var(--fm-hover) !important;
}
::ng-deep .fm-card mat-cell,
::ng-deep .fm-card .mat-mdc-cell {
  font-size: 13px !important;
  color: var(--fm-text) !important;
}
::ng-deep .fm-card .icon-folder::before {
  color: #f9a825 !important;
}
::ng-deep .fm-card .icon-photo::before {
  color: #34a853 !important;
}
::ng-deep .fm-card .icon-attachment::before {
  color: #ea4335 !important;
}
::ng-deep .fm-card .icon-text_format::before {
  color: #4285f4 !important;
}
::ng-deep .fm-card .icon-grid_on::before {
  color: #0f9d58 !important;
}
.fm-card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid var(--fm-border);
  background: var(--fm-bg);
  flex-shrink: 0;
}
.fm-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 32px;
  text-align: center;
  gap: 12px;
}
.fm-empty__art {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: var(--fm-bg);
  border: 2px solid var(--fm-border);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.fm-empty__art mat-icon {
  font-size: 52px !important;
  width: 52px !important;
  height: 52px !important;
  color: #c5c7cb;
}
.fm-empty__art--muted mat-icon {
  color: #bdbdbd;
}
.fm-empty__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--fm-text);
}
.fm-empty__sub {
  margin: 0;
  font-size: 14px;
  color: var(--fm-muted);
  max-width: 360px;
  line-height: 1.5;
}
.fm-storage {
  display: flex;
  align-items: center;
  gap: 10px;
}
.fm-storage__icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  color: var(--fm-muted);
}
.fm-storage__track {
  width: 120px;
  height: 5px;
  border-radius: 999px;
  background: #e8eaed;
  overflow: hidden;
}
.fm-storage__fill {
  height: 100%;
  border-radius: 999px;
  background: var(--fm-brand);
  transition: width 0.4s ease;
}
.fm-storage__fill--warn {
  background: #f4a623;
}
.fm-storage__fill--full {
  background: var(--fm-danger);
}
.fm-storage__text {
  font-size: 12px;
  color: var(--fm-muted);
  white-space: nowrap;
}
.fm-skeleton {
  min-height: 100vh;
  background: var(--fm-bg);
}
.fm-skeleton__bar {
  height: 64px;
  background: var(--fm-surface);
  border-bottom: 1px solid var(--fm-border);
  margin-bottom: 24px;
}
.fm-skeleton__body {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.fm-skeleton__row {
  height: 20px;
  border-radius: 999px;
  background:
    linear-gradient(
      90deg,
      #ebebeb 25%,
      #d6d6d6 50%,
      #ebebeb 75%);
  background-size: 200% 100%;
  animation: fm-shimmer 1.5s ease-in-out infinite;
}
@keyframes fm-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
::ng-deep .fm-menu-item.mat-mdc-menu-item mat-icon {
  color: var(--fm-muted);
  font-size: 18px;
  width: 18px;
  height: 18px;
}
::ng-deep .fm-menu-item.mat-mdc-menu-item {
  font-size: 14px;
}
::ng-deep .fm-menu-item.fm-menu-item--danger,
::ng-deep .fm-menu-item.fm-menu-item--danger mat-icon {
  color: var(--fm-danger) !important;
}
::ng-deep .fm-menu-item.fm-menu-item--danger:hover {
  background: var(--fm-danger-light) !important;
}
.fd-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 24px 24px 0;
}
.fd-header__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--fm-brand-light);
  flex-shrink: 0;
}
.fd-header__icon-wrap mat-icon {
  color: var(--fm-brand);
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.fd-header__title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 17px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
}
.fd-header__sub {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--fm-muted);
}
.fd-content {
  padding: 16px 24px 8px !important;
  overflow: visible !important;
}
.fd-field {
  width: 100%;
  margin-top: 8px;
}
.fd-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  background: var(--fm-danger-light);
  color: var(--fm-danger);
  font-size: 13px;
  margin-bottom: 12px;
}
.fd-error mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.fd-success {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  background: rgba(52, 168, 83, 0.1);
  color: #188038;
  font-size: 13px;
  margin-top: 8px;
}
.fd-success mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.fd-actions {
  padding: 8px 24px 20px !important;
  justify-content: flex-end !important;
  gap: 8px;
}
.fd-btn-create {
  background-color: var(--fm-brand) !important;
  color: #fff !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.fd-btn-create mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
/*# sourceMappingURL=files.component.css.map */
